import 'react-native-url-polyfill/auto'

import { type Database } from '@dateability/supabase'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { createClient } from '@supabase/supabase-js'

import { IS_SERVER, IS_WEB } from '@/lib/consts'

export const supabase = createClient<Database>(
  process.env.EXPO_PUBLIC_SUPABASE_API_URL,
  process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY,
  {
    auth: {
      autoRefreshToken: !IS_SERVER,
      detectSessionInUrl: IS_WEB,
      persistSession: true,
      storage: {
        getItem: (key: string) => {
          if (IS_WEB) {
            if (typeof localStorage === 'undefined') {
              return null
            }
            return localStorage.getItem(key)
          }
          return AsyncStorage.getItem(key)
        },
        removeItem: (key: string) => {
          if (IS_WEB) {
            return localStorage.removeItem(key)
          }
          return AsyncStorage.removeItem(key)
        },
        setItem: (key: string, value: string) => {
          if (IS_WEB) {
            return localStorage.setItem(key, value)
          }
          return AsyncStorage.setItem(key, value)
        }
      }
    }
  }
)
